import React from 'react';
import './button.css';
import checkMark from './images/checkMarkWhite.png';

export default function (props) {
    return (
        <div
            onClick={props.onClick}
            style={{
                backgroundColor: '#CCCCCC',
                padding: '1.07rem 0.71rem',
                borderRadius: '0.36rem',
                maxWidth: '2.86rem',
                ...props.style
            }}
        >
            <img src={checkMark} alt={'Check mark'} width={20}/>
        </div>
    );
}